import type { GeoJsonPointLike } from './GeoLocation';

/** Coordenada o zoom: llegan como numero de mapbox/config, o como cadena desde la URL. */
export type Coordinate = string | number;

/**
 * Object to store map location data and zoom.
 */
class LocationData {
    latitude: Coordinate;
    longitude: Coordinate;
    zoom?: Coordinate;

    constructor(latitude: Coordinate, longitude: Coordinate, zoom?: Coordinate) {
      this.latitude = latitude;
      this.longitude = longitude;
      this.zoom = zoom;
    }

    /**
     * Construct from GeoJson
     */
    static fromGeoJson(txtGeo: string | GeoJsonPointLike): LocationData | undefined {
      const geo = typeof txtGeo === 'object' ? txtGeo : JSON.parse(txtGeo) as GeoJsonPointLike;
      if (geo && geo.coordinates) {
        const [lon, lat] = geo.coordinates;
        return new LocationData(lat, lon)
      }
      return undefined;
    }

    /**
     * Convert to list (for destructuring).
     *
     * Usage: [lon, lat, zoom] = this.toList();
     */
    toList() {
      return [this.longitude, this.latitude, this.zoom];
    }

    /**
     * Compare if LocationData is the same.
     *
     * Los valores pueden venir como cadena (parametros de URL), de ahi el
     * parseFloat, que ya hacia esta conversion de forma implicita.
     */
    static isEqual(location1: LocationData, location2: LocationData, margin = 1.5, zoomMargin = 0.5): boolean {
        return (
            Math.abs(parseFloat(String(location1.latitude)) - parseFloat(String(location2.latitude))) < margin &&
            Math.abs(parseFloat(String(location1.longitude)) - parseFloat(String(location2.longitude))) < margin &&
            Math.abs(parseFloat(String(location1.zoom)) - parseFloat(String(location2.zoom))) < zoomMargin
        );
    }
}

export default LocationData;
